import React from 'react';
import { YoutubeExportChannelsModal } from './YoutubeExportChannelsModal';
import { MetaAdAccountsModal } from './MetaAdAccountsModal';
import { CM360AccountsModal } from './CM360AccountsModal';
import { GoogleAdsAccountsModal } from './GoogleAdsAccountsModal';
import { ContentfulAccountsModal } from './ContentfulAccountsModal';
import { TikTokAccountsModal } from './TikTokAccountsModal';
import { ExportsDebugModal } from './ExportsDebugModal';
import { useFeatures } from '@cube3/state/src/redux/components/Hooks/useFeatures';
import { Feature } from '@cube3/state/types';

export type Platform =
  | 'YouTube'
  | 'Meta'
  | 'CM360'
  | 'Google Ads'
  | 'Contentful'
  | 'TikTok';
interface Props {
  modalContext: {
    exportTargetTypeId: string;
    platform?: Platform;
  };
}

const debugFeature = { features: ['/WORKSPACE/EXPORTS/DEBUG'] as Feature[] };

const platforms = {
  YouTube: YoutubeExportChannelsModal,
  Meta: MetaAdAccountsModal,
  CM360: CM360AccountsModal,
  GoogleAds: GoogleAdsAccountsModal,
  Contentful: ContentfulAccountsModal,
  TikTok: TikTokAccountsModal
};

export const SocialExportModal = (props: Props) => {
  const { modalContext } = props;
  const { platform } = modalContext;

  const Component = platforms[platform];
  const [debugMode] = useFeatures(debugFeature);

  if (debugMode) {
    return <ExportsDebugModal {...props} platform={platform} />;
  }

  return Component ? <Component {...props} /> : null;
};
